$shm_hitalama_dragtree_toggle $mol_check_expand
	event *
		^
		pointerdown? <=> pointerdown? null
